"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const compact_1 = __importDefault(require("lodash/compact"));
const defaultKey = ['categories'];
const keys = {
    default: defaultKey,
    categories: (params) => {
        return (0, compact_1.default)([...defaultKey, params]);
    }
};
exports.default = keys;
